import React from 'react';
import { Link } from 'react-router-dom';
//import blog3 from '../../images/blog-details/comments-author/img-1.jpg';
//import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
//import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
//import blog6 from '../../images/blog-details/author.jpg';
import blog7 from '../../images/blog-details/image-4.jpg';
import blog8 from '../../images/blog-details/image-5.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';

const BlogSingle = props => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	const submitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className={`${props.gClass} grid gap-3`}>
					<div className={`col-span-8 md:col-span-12 ${props.blRight}`}>
						<div className=''>
							<div className='mb-[70px]'>
								<h3 className='text-[34px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
									{NewsDetails.title}
								</h3>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									{NewsDetails.description}
								</p>
								<h4 className='text-[#282e3f] text-[26px] md:text-[21px] sm:text-[18px] mb-[20px]'>
									Voici quelques conseils :
								</h4>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Tout d'abord, vous devez savoir que l'assuré a l'obligation légale de prendre toutes
									les mesures raisonnables permettant de limiter les conséquences du sinistre (article
									75 de la loi du 4 avril 2014 relative aux assurances).
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Si vous ne prenez pas ces mesures raisonnables et qu'il en résulte un préjudice pour
									l'assureur, celui-ci a le droit de prétendre à une réduction de sa prestation, à
									concurrence du préjudice qu'il a subi (article 76 de la loi du 4 avril 2014 relative
									aux assurances).
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									N'hésitez donc pas à faire intervenir un corps de métier professionnel pour
									effectuer les réparations provisres urgentes (protection du toit, etc…).
									<br />
									Veillez à parallèlement informer votre assureur (voir l'article 74, §1 dont question
									ci-dessous)
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									N'ayez crainte, les frais engendrés par ces mesures raisonnables seront pris en
									charge par votre assureur.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									En effet, la loi prévoit que les frais découlant aussi bien des mesures demandées
									par l'assureur aux fins de prévenir ou d'atténuer les conséquences du sinistre que
									des mesures urgentes et raisonnables prises d'initiative par l'assuré pour prévenir
									le sinistre en cas de danger imminentu, si le sinistre a commencé, pour en prévenir
									ou en atténuer les conséquences, sont supportés par l'assureur lorsqu'ils ont été
									exposés en bon père de famille, alors même que les diligences faites l'auraient été
									sans résultat (article 106 de la loi du 4 avril 2014 relative aux assurances).
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Ensuite, il vous appartient d'informer votre assureur le plus tôt possible (article
									74, §1 de la loi du 4 avril 2014 relative aux assurances). De cette façon,
									votressureur pourra prendre les premières mesures et évaluer le mieux possible
									l'indemnisation à laquelle vous aurez droit.
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Certaines polices d'assurance prévoient le délai dans lequel vous devez déclarer le
									sinistre à votre assureur. Soyez-y attentif car ce délai peut être très bref !
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Enfin, vous devez fournir sans retard à l'assureur tous renseignements utiles et
									répondre aux demandes qui vous sont faites pour déterminer les circonstances et
									fixer l'étendue du sinistre (article 74, §2 de la loi du 4 avril 2014 relative aux
									assurances).
								</p>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									Vous l'aurez compris, il est important de prévenir rapidement votre assureur et de
									coopérer avec celui-ci et ce, dans votre propre intérêt !
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BlogSingle;
